import Image from 'next/image';
import React from 'react';
import { replaceImageUrl } from '../../../utils/helpers/imageUtils';

/**
 * Footer Brand Component
 * Displays company logo and description
 * 
 * @param {Object} footerIcon - Company logo object
 * @param {String} description - Company description
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {Boolean} isMobile - Whether this is for mobile layout
 * @param {Boolean} fullWidth - Allow the description to use the column width
 * @param {String} className - Additional CSS classes
 */
const FooterBrand = ({ footerIcon, description, isDarkMode, isMobile = false, fullWidth = false, className = '' }) => {
    return (
        <div className={`footer-brand ${isMobile ? 'text-center mb-4' : fullWidth ? 'mb-0' : 'mb-4'} ${className}`}>
            {footerIcon?.url && (
                <Image
                    src={replaceImageUrl(footerIcon.url)}
                    alt={footerIcon.alternativeText || 'HireGo Logo'}
                    width={isMobile ? 120 : 150}
                    height={isMobile ? 55 : 70}
                    style={{ 
                        objectFit: 'contain',
                        filter: isDarkMode ? 'brightness(1.1) contrast(1.1)' : 'none',
                        transition: 'filter 0.3s ease',
                        marginBottom: isMobile ? '1rem' : '0'
                    }}
                    className={isMobile ? '' : 'mb-3'}
                />
            )}
            
            {description && (
                <p style={{
                    color: isDarkMode ? '#b8b8b8' : '#d0d0d0',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    marginBottom: isMobile || fullWidth ? '0' : '1.5rem',
                    maxWidth: isMobile ? 'none' : fullWidth ? '36rem' : '300px',
                    margin: isMobile ? '0 auto' : '0 0 1.5rem 0',
                    textAlign: isMobile ? 'start' : 'left'
                }}>
                    {description}
                </p>
            )}
        </div>
    );
};

export default FooterBrand;
